/**
 * @generated SignedSource<<2391313208bbe81d420a61d07efe3058>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskFellowContext_conversation$data = {
  readonly context: {
    readonly filters: string | null;
    readonly name: string;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "AskFellowContext_conversation";
};
export type AskFellowContext_conversation$key = {
  readonly " $data"?: AskFellowContext_conversation$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowContext_conversation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AskFellowContext_conversation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AskCopilotConversationContext",
      "kind": "LinkedField",
      "name": "context",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filters",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AskCopilotConversation",
  "abstractKey": null
};

(node as any).hash = "7be849252ef6f3ab48bb0808f6aff1ee";

export default node;
